module.exports = __webpack_public_path__ + "static/media/open_menu.a450cc10.svg";